<template>
  <div
    class="bb-timer-modal"
    @click.stop
  >
    <i
      v-if="!isHideIcon"
      class="bb-timer-modal__close icon-cross"
      @click="onClose"
    />
    <div class="bb-timer-modal-main">
      <BBTabs
        :tabsList="tabsList"
        :activeTab.sync="activeTab"
        :isSmall="true"
      />
      <BBTimerModalBody
        :isTimer="activeTab === TIMER_MODAL_TIMER_TAB_ID"
        :isSave="isSave"
        :activeTimer="activeTimer"
        :body.sync="body"
        :isErrorComment.sync="isError"
        :isErrorSelect.sync="isErrorSelect"
        :isSubproject="isSubproject"
        :isHourProject="isSubproject"
      />
    </div>
    <button
      class="bb-button bb-timer-modal__button"
      :disabled="disabledButton"
      @click="onSave"
    >
      save
    </button>
  </div>
</template>

<script>
import {TIMER_MODAL_TABS, TIMER_MODAL_TIMER_TAB_ID} from '@/constants/Tabs/timerModalTabs'
import {TIMER_STATUS} from '@/constants/timerStatus'
import {REMINDER_STATUS} from '@/constants/recurReminders'
import BBTimerModalBody from '@/components/Main/TimerControl/BBTimerModal/BBTimerModalBody'
import TimerApi from '@/api/Timer/api'
import BBTabs from '@/components/Main/BBTabs/BBPTabs'
import updateProject from '@/mixin/updateProject'

export default {
  name: 'BBTimerModal',
  components: {
    BBTabs,
    BBTimerModalBody
  },
  mixins: [updateProject],
  props: {
    isShowModal: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    tabsList: TIMER_MODAL_TABS,
    activeTab: TIMER_MODAL_TIMER_TAB_ID,
    TIMER_MODAL_TIMER_TAB_ID,
    isSave: false,
    isError: false,
    isErrorSelect: false,
    body: {}
  }),
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    isHideIcon () {
      const { subTimers = {} } = this.activeTimer
      const { status } = subTimers
      return TIMER_STATUS.COMPLETED === status
    },
    disabledButton () {
      if (this.activeTab === TIMER_MODAL_TIMER_TAB_ID) {
        const { subTimers = {} } = this.activeTimer
        const { status } = subTimers
        return this.isError || this.isErrorSelect || TIMER_STATUS.COMPLETED !== status
      }
      return this.isError || this.isErrorSelect
    },
    showModal: {
      get () {
        return this.isShowModal
      },
      set () {
        this.$emit('update:isShowModal', false)
      }
    },
    isStart: {
      get () {
        return this.$store.getters.isStart
      },
      set (data) {
        this.$store.dispatch('setStart', data)
      }
    },
    activeTimer: {
      get () {
        return this.$store.getters.activeTimer
      },
      set (data) {
        this.$store.dispatch('setActiveTimer', data)
      }
    },
    time: {
      get () {
        return this.$store.getters.time
      },
      set (data) {
        this.$store.dispatch('setTimer', data)
      }
    },
    projectsList: {
      get () {
        return this.$store.getters.projectsList
      },
      set (data) {
        this.$store.dispatch('setProjectsList', data)
      }
    },
    requestsList: {
      get () {
        return this.$store.getters.requestsList
      },
      set (data) {
        this.$store.dispatch('setRequestsList', data)
      }
    },
    isProjectTimer () {
      const { instanceStatus } = this.activeTimer
      return REMINDER_STATUS.PROJECT === instanceStatus
    },
    isSubproject () {
      const { subprojectId, subTimers = {} } = this.activeTimer
      const { isSub = false } = subTimers
      return subprojectId && isSub
    },
    isHourProject () {
      const { subprojectId, subTimers = {} } = this.activeTimer
      const { isSub = false } = subTimers
      return subprojectId && !isSub
    }
  },
  methods: {
    onClose () {
      this.showModal = false
      const { subTimers = {} } = this.activeTimer
      const { _id } = subTimers
      if (!_id) return
      this.createCommentTimer()
      this.$store.dispatch('setShowTimer', true)
    },
    checkValidation () {
      const { comment = '', companyIsTab, companies = [] } = this.body
      const [company] = companies
      this.isError = !comment
      this.isErrorSelect = companyIsTab && !company
      return this.isError || this.isErrorSelect
    },
    async onSave () {
      if (this.checkValidation()) return
      this.isSave = !this.isSave
      if (this.activeTab === TIMER_MODAL_TIMER_TAB_ID) {
        await this.createSubTimer()
        this.time = {
          ...this.time,
          hours: '00',
          minutes: '00',
          seconds: '00'
        }
      } else {
        const { subTimers = {} } = this.activeTimer
        const { status = TIMER_STATUS.SAVED } = subTimers
        if (status !== TIMER_STATUS.SAVED) return
      }
      setTimeout(() => {
        this.showModal = false
      }, 0)
    },
    updateRowTime (newTotalTime, data) {
      const { project } = this.activeTimer
      const items = this.isProjectTimer ? this.projectsList : this.requestsList
      const currentItem = items.find((el) => el.id === project)
      if (!currentItem) return
      if (this.isProjectTimer) {
        this.updateProject({
          row: currentItem,
          isSubproject: false,
          isHourProject: this.isHourProject || this.isSubproject,
          data
        })
      } else {
        const { totalTime: newTotalTime } = data
        const { totalTime } = currentItem
        currentItem.totalTime = totalTime + newTotalTime
        data.user = [{_id: data.user}]
        currentItem.comments.unshift(data)
      }
    },
    async createSubTimer () {
      const {
        project,
        requestProject,
        subprojectId,
        subTimers = {},
        instanceStatus
      } = this.activeTimer

      const body = {
        user: this.userInfo ? this.userInfo.id : '5f8097e4e06d0800124c7a5d',
        endDate: this.time.fullDate,
        project: this.isProjectTimer ? subprojectId ? [project, subprojectId] : [project] : undefined,
        request: this.isProjectTimer ? undefined : [requestProject],
        instanceStatus,
        subTimerId: subTimers._id,
        ...this.body
      }
      try {
        const { data } = await TimerApi.createSubTimer(body)
        const { totalTime } = data
        this.updateRowTime(totalTime, data)
        this.activeTimer = {
          subTimers: {
            status: TIMER_STATUS.SAVED
          }
        }
        this.body = {}
        this.$store.dispatch('setShowTimer', false)
      } catch (err) {
        console.error(err)
      }
    },
    async createCommentTimer () {
      const {
        project,
        requestProject,
        subprojectId,
        subTimers = {},
        instanceStatus
      } = this.activeTimer
      const { _id } = subTimers
      const body = {
        ...this.body,
        project: this.isProjectTimer ? subprojectId ? [project, subprojectId] : [project] : undefined,
        request: this.isProjectTimer ? undefined : [requestProject],
        instanceStatus
      }
      try {
        const { data } = await TimerApi.createCommentTimer(body, _id)
        const { subTimers } = this.activeTimer
        const { companies } = data
        this.activeTimer = {
          ...this.activeTimer,
          subTimers: {
            ...subTimers,
            ...this.body,
            companies
          }
        }
        this.$store.dispatch('setShowTimer', true)
      } catch (err) {
        console.error(err)
      }
    }
  },
  watch: {
    body (newVal) {
      if (newVal) this.isError = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bb-timer-modal {
    width: 438px;
    min-height: 426px;
    background: $color-white;
    border-radius: 8px;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    z-index: 5;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: auto;

    &:before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: -1;
    }

    &__close {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 16px;
      top: 14px;
      font-size: 18px;
      width: 24px;
      height: 24px;
      cursor: pointer;
      transition: 0.2s;
      color: $color-silver;
    }

    &__button {
      margin: 0 auto 20px auto;
      width: 103px;
      text-transform: uppercase;
    }
  }

  .bb-timer-modal-main {
    padding: 36px 18px 18px 18px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/TimerControl/BBTimerModal/BBTimerModal.vue